import { UsersStatus } from '@40seas/entities/users';
import { EnumColor } from '@40seas/frontend/common/providers';

export const usersStatusColorMapping = {
    [UsersStatus.Pending]: 'default',
    [UsersStatus.Active]: 'success',
} as { [key in UsersStatus]: EnumColor };
